import React, { useEffect, useState, useRef } from "react";
import { getQuestionsBySubjectMainsPractice } from "../services/mainspractice";
import "../ChatWindow.css";

function Mainspractice({
  prelimquestion,
  sender,
  message,
  setMessages,
  onSend,
  isScrolling,
  setIsScrolling,
}) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  // Auto-scroll functionality
  const messagesStartRef = useRef(null);
  const contentRef = useRef(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);

  const handleUserScroll = () => {
    setIsUserScrolling(true);
    // Reset after some time
    setTimeout(() => {
      setIsUserScrolling(false);
    }, 2000);
  };

  // Auto-scroll to new content
  useEffect(() => {
    if (messagesStartRef.current && !isScrolling) {
      const rect = messagesStartRef.current.getBoundingClientRect();
      if (rect.top > 0) {
        messagesStartRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  });

  // Scroll to bottom for bot responses
  useEffect(() => {
    if (sender === "bot" && contentRef.current && questions.length > 0) {
      const responseDiv = contentRef.current;
      responseDiv.scrollTop = responseDiv.scrollHeight;
    }
  }, [questions]);

  // Add scroll listener
  useEffect(() => {
    const container = document.querySelector(".chat-window-container");
    if (container) {
      container.addEventListener("scroll", handleUserScroll);
      return () => {
        container.removeEventListener("scroll", handleUserScroll);
      };
    }
  }, []);

  // Helpers
  const cleanText = (text) => text?.replace(/\s+/g, " ")?.trim();
  const getYear = (text) => {
    const match = text?.match(/\b(19|20)\d{2}\b/);
    return match ? match[0] : "";
  };

  useEffect(() => {
    const fetchQuestions = async () => {
      // Only fetch if we haven't fetched before
      if (hasFetched.current) return;
      if (prelimquestion) {
        try {
          const data = await getQuestionsBySubjectMainsPractice(
            prelimquestion,
            5,
          );
          setQuestions(data || []);
          hasFetched.current = true;
        } catch (err) {
          setError(err.message || "Failed to load questions");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchQuestions();
  }, [prelimquestion]);

  const handleQuestionClick = (question, subject) => {
    const payload = {
      message: question,
      prompt: subject === "Essay" ? "Essay Guidance" : "See a Model Answer",
    };
    onSend(payload);
  };

  return (
    <div className={`message w-100 ${sender === "bot" ? "bot" : "user"}`}>
      {!isScrolling && <div ref={messagesStartRef}></div>}
      <div ref={contentRef} className="message-content">
        {sender === "user" ? (
          <div className="user-message chat-bubble user mcq-bot-message">
            <p>{message}</p>
          </div>
        ) : (
          <>
            {questions.length > 0 ? (
              <div className="content-div px-0">
                <div
                  className="d-flex"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img
                      src="/assets/images/Follow-up-questions.svg"
                      alt="follow"
                    />
                    <span className="sq-title" style={{ marginLeft: "7px" }}>
                      {prelimquestion} Questions
                    </span>
                  </div>
                </div>

                <div id="sq-res">
                  {questions.map((question, index) => (
                    <div
                      key={index}
                      className="suggested-questions mt-3"
                      onClick={() =>
                        handleQuestionClick(question.qstn, prelimquestion)
                      }
                    >
                      <span className="btn-sq">
                        <span className="que-con question">
                          {cleanText(question.qstn)}
                        </span>
                        <span className="que-con">{question.year}</span>
                      </span>

                      <div className="d-flex" style={{ alignItems: "center" }}>
                        <img
                          src="/assets/images/right-arrow.svg"
                          className="icon-prompt"
                          alt="Right arrow"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(Mainspractice);
